/* used to make extending classes instanceof'able of 'Class' (not just 'object') */

export class Class {}
